<div class="pt-3">
  <div class="alert alert-info" role="alert">
    Mockup: static example data, nothing here saves.
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">Purchases</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Invoice&nbsp;#</th>
        <th scope="col">Item</th>
        <th scope="col">Variant</th>
        <th scope="col">Qty</th>
        <th scope="col">Unit Price</th>
        <th scope="col">Discount</th>
        <th scope="col">Location</th>
        <th scope="col">Status</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody style="line-height: 16px;">
      <tr *ngFor="let purchase of purchases" [class.text-muted]="!purchase.canReturn">
        <td class="text-nowrap">{{ purchase.date }}</td>
        <td>#{{ purchase.invoice }}</td>
        <td>{{ purchase.item }}</td>
        <td>
          {{ purchase.variant }}
          <span *ngIf="!purchase.variant" class="text-muted">&mdash;</span>
        </td>
        <td>{{ purchase.qty }}</td>
        <td>{{ purchase.unitPrice }}</td>
        <td>
          {{ purchase.discount }}
          <span *ngIf="!purchase.discount" class="text-muted">&mdash;</span>
        </td>
        <td>{{ purchase.location }}</td>
        <td>{{ purchase.status }}</td>
        <td class="table-button-cell">
          <div class="d-flex justify-content-end" style="gap: 12px;" *ngIf="purchase.canReturn">
            <button type="button" class="btn btn-sm btn-secondary table-12px-button">Return</button>
            <button type="button" class="btn btn-sm btn-secondary table-12px-button">Exchange</button>
          </div>
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
